import { configure } from "mobx";

// Mobx gets real grumpy if this isn't the first thing loaded into the repo
// https://github.com/mobxjs/mobx/discussions/2607
configure({
  useProxies: "never",
});
